var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-teacher-edit-audit" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "standard-size-16 color-gray-10",
      },
      [
        _vm.baseInfo.templateList && _vm.baseInfo.templateList.length
          ? _vm._l(_vm.baseInfo.templateList, function (item) {
              return _c(
                "div",
                { key: item.fieldCode, staticClass: "mb35 font-bolder" },
                [
                  _vm._v("\n        " + _vm._s(item.fieldName) + "\n        "),
                  _c(
                    "yxtf-row",
                    {
                      staticClass: "mv24 font-normal font-size-14",
                      attrs: { type: "flex" },
                    },
                    [
                      _c(
                        "yxtf-col",
                        { staticClass: "mh2 felx-center", attrs: { span: 24 } },
                        [
                          item.customerType === _vm.CUSTOM_TYPES.IMAGE
                            ? _c(
                                "div",
                                { staticClass: "mt8" },
                                [
                                  item.content
                                    ? _c("yxt-image", {
                                        staticClass:
                                          "width120 height120 b-radius4",
                                        attrs: {
                                          src: item.content,
                                          "preview-src-list": [item.content],
                                        },
                                      })
                                    : _c(
                                        "div",
                                        { staticClass: "color-gray-7" },
                                        [_vm._v("--")]
                                      ),
                                ],
                                1
                              )
                            : _c(
                                "yxtf-tooltip",
                                {
                                  attrs: {
                                    "open-filter": true,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(item.content || "--")
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("div", { staticClass: "color-gray-7" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.content || "--") +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            })
          : _c("div", { staticClass: "color-gray-7" }, [
              _vm._v(
                _vm._s(
                  _vm
                    .$t("pc_biz_tip_teacher_field_deleted")
                    .d("本次修改的讲师字段已被删除")
                )
              ),
            ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }